(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Artist Packages Section Functionality
    /*****************************************************/
    if ($(".artist-packages-section").length) {
      console.log("artist-packages.js initiated");

      // Function to check and toggle sticky behavior for a specific section
      function checkStickyBehavior($section = null) {
        const $sections = $section || $(".artist-packages-section");

        $sections.each(function () {
          const $currentSection = $(this);
          const $sidebar = $currentSection.find(".packages-sidebar");
          const $detail = $currentSection.find(".package-detail");

          // Only check on desktop
          if (window.matchMedia("(min-width: 768px)").matches) {
            const sidebarHeight = $sidebar.outerHeight(true);
            const detailHeight = $detail.outerHeight(true);
            const viewportHeight = $(window).height();
            const navOffset = 36 + 96; // 2rem + 5.18rem in pixels (adjust if needed)
            const availableHeight = viewportHeight - navOffset;

            // Disable sticky if sidebar is taller than detail container or available viewport space
            if (sidebarHeight > detailHeight || sidebarHeight > availableHeight) {
              $sidebar.removeClass("sticky-enabled");
            } else {
              $sidebar.addClass("sticky-enabled");
            }
          } else {
            // Remove sticky class on mobile
            $sidebar.removeClass("sticky-enabled");
          }
        });
      }

      // Function to update package type buttons for a region within a specific section
      function updatePackageTypeButtons(regionSlug, $section) {
        // Find the first region data to get package types
        const $regionPackages = $section.find(`.region-packages[data-region="${regionSlug}"]`);
        const $packageTypes = $regionPackages.find(".package-type-group");

        // Clear current package type buttons
        $section.find(".package-type-buttons").empty();

        // Clear and update mobile package type select
        const $mobileSelect = $section.find(".package-type-select");
        $mobileSelect.empty();

        // Add new package type buttons and mobile options
        $packageTypes.each(function (index) {
          const $group = $(this);
          const typeSlug = $group.data("type");
          const typeName = $group.find(".package-list-item").first().data("type");

          // Get the actual type name from the first package or derive it
          let displayName = typeSlug.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
          if (typeSlug === "2-day-packages") displayName = "2 Day Packages";
          if (typeSlug === "1-day-packages") displayName = "1 Day Packages";
          if (typeSlug === "other-packages") displayName = "Other Packages";

          // Add desktop button
          const $newBtn = $(`
            <button class="btn btn-outline package-type-btn ${index === 0 ? "active" : ""}"
                    data-type="${typeSlug}"
                    data-type-index="${index}">
              ${displayName}
            </button>
          `);

          $section.find(".package-type-buttons").append($newBtn);

          // Add mobile option
          const $newOption = $(`
            <option value="${typeSlug}" data-type-index="${index}" ${index === 0 ? "selected" : ""}>
              ${displayName}
            </option>
          `);

          $mobileSelect.append($newOption);
        });

        // Show first package type group
        $packageTypes.hide();
        $packageTypes.first().show();

        // Check sticky behavior after updating content
        setTimeout(() => checkStickyBehavior($section), 100);
      }

      // Helper function to show first package for a region within a specific section
      function showFirstPackageForRegion(regionSlug, $section) {
        const $firstPackageType = $section.find(`.region-packages[data-region="${regionSlug}"] .package-type-group`).first();
        const typeSlug = $firstPackageType.data("type");

        // Use mobile-aware function
        showAllPackagesForMobile(regionSlug, typeSlug, $section);
      }

      // Helper function to show first package for a type within a specific section
      function showFirstPackageForType(regionSlug, typeSlug, $section) {
        // Remove active from all package list items in this section
        $section.find(".package-list-item").removeClass("active");

        // Find and activate first package in the type
        const $firstPackage = $section.find(`.package-list-item[data-region="${regionSlug}"][data-type="${typeSlug}"]`).first();
        $firstPackage.addClass("active");

        // Get package details
        const packageSlug = $firstPackage.data("package");

        // Hide all package detail contents in this section
        $section.find(".package-detail-content").removeClass("active");

        // Show target package detail
        $section
          .find(`.package-detail-content[data-package="${packageSlug}"][data-region="${regionSlug}"][data-type="${typeSlug}"]`)
          .addClass("active");

        // Check sticky behavior after content change
        setTimeout(() => checkStickyBehavior($section), 100);
      }

      // Mobile-specific function to show all packages for a region and type within a specific section
      function showAllPackagesForMobile(regionSlug, typeSlug, $section) {
        // Check if we're on mobile
        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        if (isMobile) {
          // Hide all package detail contents first in this section
          $section.find(".package-detail-content").removeClass("active");

          // Show all package detail contents matching the region and type
          $section.find(`.package-detail-content[data-region="${regionSlug}"][data-type="${typeSlug}"]`).addClass("active");

          // Close all accordion bodies (reset accordion state)
          $section.find(".package-detail-content.active").removeClass("accordion-open");
        } else {
          // Use desktop behavior (show first package only)
          showFirstPackageForType(regionSlug, typeSlug, $section);
        }
      }

      // Region Button Click Handler
      $(".artist-packages-section").on("click", ".region-btn", function () {
        const $clickedBtn = $(this);
        const $section = $clickedBtn.closest(".artist-packages-section");
        const targetRegion = $clickedBtn.data("region");
        const regionIndex = $clickedBtn.data("region-index");

        // Update active state for region buttons within this section
        $section.find(".region-btn").removeClass("active");
        $clickedBtn.addClass("active");

        // Hide all region packages in sidebar within this section
        $section.find(".region-packages").hide();

        // Show target region packages
        $section.find(`.region-packages[data-region="${targetRegion}"]`).show();

        // Update sidebar title with new region name
        const regionName = $clickedBtn.text().trim();
        $section.find(".sidebar-title .region-name").text(regionName);

        // Update package type buttons for the new region
        updatePackageTypeButtons(targetRegion, $section);

        // Show first package type and first package for the new region
        showFirstPackageForRegion(targetRegion, $section);

        // Check sticky behavior after region change
        setTimeout(() => checkStickyBehavior($section), 100);
      });

      // Mobile Region Select Change Handler
      $(".artist-packages-section").on("change", ".region-select", function () {
        const $select = $(this);
        const $section = $select.closest(".artist-packages-section");
        const targetRegion = $select.val();
        const $selectedOption = $select.find("option:selected");
        const regionIndex = $selectedOption.data("region-index");

        // Update corresponding desktop button within this section
        $section.find(".region-btn").removeClass("active");
        $section.find(`.region-btn[data-region="${targetRegion}"]`).addClass("active");

        // Hide all region packages in sidebar within this section
        $section.find(".region-packages").hide();

        // Show target region packages
        $section.find(`.region-packages[data-region="${targetRegion}"]`).show();

        // Update sidebar title with new region name
        const regionName = $selectedOption.text().trim();
        $section.find(".sidebar-title .region-name").text(regionName);

        // Update package type buttons for the new region
        updatePackageTypeButtons(targetRegion, $section);

        // Show first package type and first package for the new region
        showFirstPackageForRegion(targetRegion, $section);

        // Check sticky behavior after region change
        setTimeout(() => checkStickyBehavior($section), 100);
      });

      // Package Type Button Click Handler
      $(".artist-packages-section").on("click", ".package-type-btn", function () {
        const $clickedBtn = $(this);
        const $section = $clickedBtn.closest(".artist-packages-section");
        const targetType = $clickedBtn.data("type");
        const currentRegion = $section.find(".region-btn.active").data("region");

        // Update active state for package type buttons within this section
        $section.find(".package-type-btn").removeClass("active");
        $clickedBtn.addClass("active");

        // Update mobile select to match within this section
        $section.find(".package-type-select").val(targetType);

        // Hide all package type groups in current region within this section
        $section.find(`.region-packages[data-region="${currentRegion}"] .package-type-group`).hide();

        // Show target package type group
        $section.find(`.region-packages[data-region="${currentRegion}"] .package-type-group[data-type="${targetType}"]`).show();

        // Show first package of the selected type (mobile-aware)
        showAllPackagesForMobile(currentRegion, targetType, $section);

        // Check sticky behavior after type change
        setTimeout(() => checkStickyBehavior($section), 100);
      });

      // Mobile Package Type Select Change Handler
      $(".artist-packages-section").on("change", ".package-type-select", function () {
        const $select = $(this);
        const $section = $select.closest(".artist-packages-section");
        const targetType = $select.val();
        const currentRegion = $section.find(".region-btn.active").data("region") || $section.find(".region-select").val();

        // Update corresponding desktop button within this section
        $section.find(".package-type-btn").removeClass("active");
        $section.find(`.package-type-btn[data-type="${targetType}"]`).addClass("active");

        // Hide all package type groups in current region within this section
        $section.find(`.region-packages[data-region="${currentRegion}"] .package-type-group`).hide();

        // Show target package type group
        $section.find(`.region-packages[data-region="${currentRegion}"] .package-type-group[data-type="${targetType}"]`).show();

        // Show all packages of the selected type for mobile
        showAllPackagesForMobile(currentRegion, targetType, $section);

        // Check sticky behavior after type change
        setTimeout(() => checkStickyBehavior($section), 100);
      });

      // Package List Item Click Handler
      $(".artist-packages-section").on("click", ".package-list-item", function () {
        const $clickedItem = $(this);
        const $section = $clickedItem.closest(".artist-packages-section");
        const packageSlug = $clickedItem.data("package");
        const regionSlug = $clickedItem.data("region");
        const typeSlug = $clickedItem.data("type");

        // Update active state for package list items within this section
        $section.find(".package-list-item").removeClass("active");
        $clickedItem.addClass("active");

        // Hide all package detail contents within this section
        $section.find(".package-detail-content").removeClass("active");

        // Show target package detail
        $section
          .find(`.package-detail-content[data-package="${packageSlug}"][data-region="${regionSlug}"][data-type="${typeSlug}"]`)
          .addClass("active");
      });

      // Mobile Package Detail Header Click Handler (Accordion)
      $(".artist-packages-section").on("click", ".package-detail-header", function () {
        // Only handle accordion on mobile
        if (window.matchMedia("(max-width: 767px)").matches) {
          const $header = $(this);
          const $section = $header.closest(".artist-packages-section");
          const $content = $header.closest(".package-detail-content.active");
          const $body = $content.find(".package-detail-body");

          // Toggle accordion state
          $content.toggleClass("accordion-open");
          $body.slideToggle(200);
        }
      });

      // Initialize each section on page load - make sure first region/type/package are properly displayed
      $(".artist-packages-section").each(function () {
        const $section = $(this);
        const $firstRegion = $section.find(".region-btn.active");
        if ($firstRegion.length) {
          const firstRegionSlug = $firstRegion.data("region");
          const $firstTypeGroup = $section.find(`.region-packages[data-region="${firstRegionSlug}"] .package-type-group`).first();

          if ($firstTypeGroup.length) {
            const firstTypeSlug = $firstTypeGroup.data("type");
            showAllPackagesForMobile(firstRegionSlug, firstTypeSlug, $section);
          }
        }
      });

      // Initialize sticky behavior on page load
      $(window).on("load", function () {
        checkStickyBehavior();
      });

      // Re-check on window resize
      $(window).on("resize", function () {
        setTimeout(checkStickyBehavior, 150);

        // Re-check mobile behavior on resize (for device rotation, etc.)
        setTimeout(function () {
          $(".artist-packages-section").each(function () {
            const $section = $(this);
            const currentRegion = $section.find(".region-btn.active").data("region") || $section.find(".region-select").val();
            const currentType =
              $section.find(".package-type-btn.active").data("type") || $section.find(".package-type-select").val();

            if (currentRegion && currentType) {
              showAllPackagesForMobile(currentRegion, currentType, $section);
            }
          });
        }, 200);
      });
    }
  });
})(jQuery);
